export const LOGIN_COMPANY = "LOGIN_COMPANY";
export const LOGIN_COMPANY_SUCCESS = "LOGIN_COMPANY_SUCCESS";
export const LOGIN_COMPANY_FAILED = "LOGIN_COMPANY_FAILED";
export const LOGOUT_COMPANY = "LOGOUT_COMPANY";
export const LOGOUT_COMPANY_FAILED = "LOGOUT_COMPANY_FAILED";
